module.exports = __webpack_public_path__ + "img/yiyuan1.866dafb2.png";